import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.pricePlan')
  .factory('$pricePlanBundle', PricePlanBundleObjectFactory);

function PricePlanBundleObjectFactory($bringozFactory: $bringozFactory,
                                      PricePlanBundleAPI: BringozApi,
                                      PricePlanBundle_DS: DataStoreConfig) {

  function $pricePlanBundle(id: string) {
    return $bringozFactory(id, PricePlanBundleAPI, PricePlanBundle_DS);
  }

  return $pricePlanBundle;
}
